import { type FormEvent, useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import config from '../config';

export default function LoginPage() {
  const { login, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Someone already signed in who lands on /login (a stale bookmark, or the
  // back button after signing in) should go where they were headed.
  if (!authLoading && user) return <Navigate to={from} replace />;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="auth-page">
      <Link to="/login" className="auth-brand">Language Lab</Link>
      <p className="auth-tagline">
        Read the grammar, then drill it. Your progress follows you between devices.
      </p>
      <div className="form-card">
        <h1 className="form-title">Sign in</h1>
        <form onSubmit={handleSubmit} className="form">
          <label className="field">
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
          </label>
          <label className="field">
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
          </label>
          {error && <p className="error">{error}</p>}
          <button type="submit" className="btn btn--primary btn--block" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
      {config.registrationOpen ? (
        <p className="auth-alt muted">
          No account yet? <Link to="/register" state={location.state}>Create one</Link>
        </p>
      ) : (
        <p className="auth-alt muted">This is a private site. Sign-ups are closed.</p>
      )}
    </main>
  );
}
